var _defs, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 1.5,
    fill: "#C08A7A",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1,
    fill: "#C08A7A",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 0,
    r: 1,
    fill: "#C08A7A",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 40,
    r: 1,
    fill: "#C08A7A",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 1,
    fill: "#C08A7A",
    opacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#FAF8F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#pattern1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionBg1);
export default __webpack_public_path__ + "static/media/section-bg-1.26b8ce779912b66171390f6cf7a9c953.svg";
export { ForwardRef as ReactComponent };